import script from "./pagetemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./pagetemplate.vue?vue&type=script&setup=true&lang=js"

import "./pagetemplate.vue?vue&type=style&index=0&id=f04e4d2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f04e4d2e"]])

export default __exports__